import { render, staticRenderFns } from "./prjMember.vue?vue&type=template&id=13842737&scoped=true"
import script from "./prjMember.vue?vue&type=script&lang=js"
export * from "./prjMember.vue?vue&type=script&lang=js"
import style0 from "./prjMember.vue?vue&type=style&index=0&id=13842737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13842737",
  null
  
)

export default component.exports